import React, { Component } from 'react'
import CreativeContent from 'Containers/CreativeContent'
// const params = ?form_data=%7B%22datasource%22%3A%22679__table%22%2C%22viz_type%22%3A%22customized_pivot_table%22%2C%22slice_id%22%3A4740%2C%22url_params%22%3A%7B%7D%2C%22granularity_sqla%22%3A%22date_time%22%2C%22time_grain_sqla%22%3A%22P1D%22%2C%22time_range%22%3A%22No+filter%22%2C%22pandas_aggfunc%22%3A%22sum%22%2C%22pivot_margins%22%3Atrue%2C%22display_precision%22%3A6%2C%22number_format%22%3A%22SMART_NUMBER%22%2C%22combine_metric%22%3Atrue%2C%22reverse_columns%22%3Afalse%2C%22sortable%22%3Afalse%2C%22heatmap%22%3Anull%2C%22heatmap_color%22%3A%7B%22a%22%3A1%2C%22b%22%3A193%2C%22g%22%3A209%2C%22r%22%3A0%7D%2C%22fixed_metrics%22%3Afalse%2C%22fixed_horizontal%22%3A%22No%22%2C%22fixed_vertical%22%3A%22No%22%2C%22cell_tooltip%22%3A%22No%22%2C%22fill_value%22%3A%22-%22%2C%22metrics%22%3A%5B%7B%22expressionType%22%3A%22SIMPLE%22%2C%22column%22%3A%7B%22column_name%22%3A%22amount%22%2C%22description%22%3Anull%2C%22expression%22%3Anull%2C%22filterable%22%3Atrue%2C%22groupby%22%3Atrue%2C%22id%22%3A11134%2C%22is_dttm%22%3Afalse%2C%22optionName%22%3A%22_col_amount%22%2C%22python_date_format%22%3Anull%2C%22type%22%3A%22NUMERIC%22%2C%22verbose_name%22%3Anull%7D%2C%22aggregate%22%3A%22SUM%22%2C%22sqlExpression%22%3Anull%2C%22hasCustomLabel%22%3Atrue%2C%22fromFormData%22%3Atrue%2C%22label%22%3A%22Amount%22%2C%22optionName%22%3A%22metric_elctjyw0kg_kygf31x51wo%22%7D%2C%7B%22expressionType%22%3A%22SIMPLE%22%2C%22column%22%3A%7B%22column_name%22%3A%22ebitda_status%22%2C%22description%22%3Anull%2C%22expression%22%3Anull%2C%22filterable%22%3Atrue%2C%22groupby%22%3Atrue%2C%22id%22%3A15297%2C%22is_dttm%22%3Afalse%2C%22optionName%22%3A%22_col_ebitda_status%22%2C%22python_date_format%22%3Anull%2C%22type%22%3A%22STRING%22%2C%22verbose_name%22%3Anull%7D%2C%22aggregate%22%3A%22COUNT_DISTINCT%22%2C%22sqlExpression%22%3Anull%2C%22hasCustomLabel%22%3Atrue%2C%22fromFormData%22%3Atrue%2C%22label%22%3A%22Ebitda+Count%22%2C%22optionName%22%3A%22metric_0koj6x8811oi_sbwxpqv3xzq%22%7D%5D%2C%22adhoc_filters%22%3A%5B%5D%2C%22groupby%22%3A%5B%22month%22%2C%22store_name%22%5D%2C%22columns%22%3A%5B%22sub_acc_name%22%5D%2C%22row_limit%22%3A200000%2C%22trending_columns%22%3A%5B%5D%2C%22trending_threshold%22%3A0%2C%22trending_percentage%22%3A%22No%22%2C%22trending_abs%22%3A%22No%22%7D

class CreativeContentList extends Component {
  state = {}
  render() {
    return (
      <iframe
        title="superset"
        width="1000"
        height="700"
        seamless
        frameBorder="0"
        scrolling="no"
      ></iframe>
    )
  }
}

export default CreativeContentList

// // 1. metrics:
// aggregate: "SUM",
// column: {
//   column_name: "amount" // change
//   description: null
//   expression: null
//   filterable: true
//   groupby: true
//   id: 11134  // change
//   is_dttm: false  // change
//   optionName: "_col_amount"
//   python_date_format: null
//   type: "NUMERIC"  // change
//   verbose_name: null
// }
